module.exports = __webpack_public_path__ + "img/Shape-ellipse.30a2377c.svg";